module.exports = __webpack_public_path__ + "codicon.d91540fa.ttf";